import React from "react";
import "./ProfitLossAccount.scss";
import expense from "../../../assets/Reports/profit-and-loss1.png";
import income from "../../../assets/Reports/profit-and-loss2.png";

const ProfitLossAccount = () => {
  return (
    <>
      <div className="profit_loss_acc">
        <div className="container">
          <div className="heading_box">Profit Loss Account</div>
          <div className="my-5 text-center">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                <img src={expense} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                <img src={income} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfitLossAccount;
